// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag {
  position: relative;
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  color: #fff;
}
.tag--has-close {
  padding: 3px 13px;
}
.tag__close {
  position: absolute;
  top: 3px;
  right: 5px;
  cursor: pointer;
}
.tag__close:hover {
  opacity: 0.8;
}
.tag--sm {
  font-size: 14px;
}
.tag--md {
  font-size: 16px;
}
.tag--lg {
  font-size: 18px;
}
@media (max-width: 1920px) {
  .tag--sm {
    font-size: 12px;
  }
  .tag--md {
    font-size: 14px;
  }
  .tag--lg {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Tag/Tag.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EAEC,WAAA;AAFH;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAJJ;AAMI;EACE,YAAA;AAJN;AAQE;EACE,eAAA;AANJ;AASE;EACE,eAAA;AAPJ;AAUE;EACE,eAAA;AARJ;AAWE;EACE;IAAQ,eAAA;EARV;EASE;IAAQ,eAAA;EANV;EAOE;IAAQ,eAAA;EAJV;AACF","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.tag {\r\n  position: relative;\r\n  display: inline-block;\r\n  padding: 3px 10px;\r\n  border-radius: 6px;\r\n  // Цвет текста по умолчанию, если не передан инлайн, можно задать здесь\r\n   color: #fff;\r\n\r\n  // Модификатор для паддинга, если есть кнопка закрытия\r\n  &--has-close {\r\n    padding: 3px 13px;\r\n  }\r\n\r\n  &__close {\r\n    position: absolute;\r\n    top: 3px;\r\n    right: 5px;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  &--sm {\r\n    font-size: 14px;\r\n  }\r\n\r\n  &--md {\r\n    font-size: 16px;\r\n  }\r\n\r\n  &--lg {\r\n    font-size: 18px;\r\n  }\r\n\r\n  @media (max-width: 1920px) {\r\n    &--sm { font-size: 12px; }\r\n    &--md { font-size: 14px; }\r\n    &--lg { font-size: 18px; }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
